import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const usePinParticipantNote = ({ participantId }: { participantId: number }) => {
	const queryClient = useQueryClient();
	const queryKey = ["participant-notes", { participantId }];

	return useMutation({
		mutationFn: async ({ noteId, pinned }: { noteId: number; pinned: boolean }) => {
			return EndpointsService.dataRetriever.pinParticipantNote({
				noteId,
				body: { pinned },
			});
		},

		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: queryKey,
			});
		},
	});
};
